import { render, staticRenderFns } from "./manageUniversityExamQuestionsItem.vue?vue&type=template&id=54e560cc"
import script from "./manageUniversityExamQuestionsItem.vue?vue&type=script&lang=js"
export * from "./manageUniversityExamQuestionsItem.vue?vue&type=script&lang=js"
import style0 from "./manageUniversityExamQuestionsItem.vue?vue&type=style&index=0&id=54e560cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports